import React from 'react';

const Grayscale = ({ component }) => (
  <div style={{ flex: 1, filter: 'grayscale(1)' }}>{component}</div>
);

export default Grayscale;
